export default {
  init() {
    // JavaScript to be fired on all pages
      var $hamburger = $('.hamburger');
      $hamburger.on('click', function() {
          $hamburger.toggleClass('is-active');

          // Do something else, like open/close menu
      });

      $('body').on('click', '#factsFront .owl-prev', function () {
          var imgFactsSlider = $('.owl-item.active').children('.item-fact').attr('data-image');
          $('.left-side img').css({
              'opacity' : '0',
          });
          $('.left-side img').attr('src', imgFactsSlider);
          $('.left-side img').animate({
              opacity: 1,
          }, 500);
      });

      $('body').on('click', '#factsFront .owl-next' ,function () {
          var imgFactsSlider = $('.owl-item.active').children('.item-fact').attr('data-image');
          $('.left-side img').css({
              'opacity': '0',
          });
          $('.left-side img').attr('src', imgFactsSlider);
          $('.left-side img').animate({
              opacity: 1,
          }, 500);
      });

      $('.accordion .card-header').click(function() {
          if($(this).next().hasClass('show')) {
              $(this).find('.header-wrap').css({
                  'background' : 'white',
                  'color' : 'black',
              });

              $(this).find('.icon').text('+');

          } else {
              $(this).parent().parent().find('.header-wrap').css({
                  'background' : 'white',
                  'color' : 'black',
              });

              $(this).parent().parent().find('.icon').text('+');

              $(this).find('.header-wrap').css({
                  'background' : '#45555f',
                  'color' : 'white',
              });

              $(this).find('.icon').text('-');
          }
      })

      $('.collapse').siblings('.card-header').children().css({
          'background' : 'white',
          'color' : 'black',
      });

      $('.collapse.show').siblings('.card-header').children().css({
          'background' : '#45555f',
          'color' : 'white',
      });

      $('#input_1_15').val($('.event-title').text());
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

      $('.bannerCarousel').owlCarousel({
          autoplay: true,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          margin: 0,
          nav: true,
          dots: false,
          loop:true,
          items: 1,
          mouseDrag: true,

      });

      $('#list-curriculum').on('change', function () {
          $('#pills-tab2 li a').eq($(this).val()).tab('show');
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js